import React, { FC } from 'react';
import { TUserStatusBottomSheetData } from './UserStatusBottomSheetContainer';

export const UserStatusBottomSheetDefaultChildren: FC<
  TUserStatusBottomSheetData
> = ({ isAnonymous, isGuest }) => (
  <div
    className="mt-1 flex flex-col gap-y-3 text-base font-regular
          first:children:font-medium first:children:!text-mofidblue-filled-primary-enabled
          last:children:!text-sm last:children:!text-gray-filled-tertiary-enabled"
  >
    {isAnonymous && (
      <>
        <div>شما هنوز به حساب کاربری خود وارد نشده‌اید!</div>
        <div>
          جهت دسترسی به امکانات مفید اپ، ‌به حساب کاربری خود وارد شوید و یا حساب
          کاربری جدید ایجاد کنید.
        </div>
      </>
    )}
    {isGuest && (
      <>
        <div>تکمیل افتتاح حساب در کارگزاری مفید</div>
        <div>
          کاربر گرامی، شما ثبت نام اولیه را در کارگزاری مفید انجام داده‌اید. جهت
          استفاده بهتر از تمامی خدمات برنامه، ابتدا ثبت‌نام خود را تکمیل نمایید.
        </div>
      </>
    )}
  </div>
);
